const CommonCard = ({
  image,
  image1,
  count,
  text,
  title,
  onClick,
  page,
  id,
  user,
  progress,
  card,
  size,
  trend,
  iconBgColor,
  onInfoClick,
}) => {
  console.log("CommonCard Rendered:", page, id);
  const isActive = page === id;

  // Get icon background color based on card type
  const getIconBgColor = () => {
    if (iconBgColor) return iconBgColor;
    if (title?.includes("Active")) return "bg-blue-50";
    if (title?.includes("Booking")) return "bg-blue-50";
    if (title?.includes("Registration")) return "bg-purple-50";
    if (title?.includes("Revenue")) return "bg-green-50";
    return "bg-gray-100";
  };

  const getProgressColor = () => {
    if (title?.includes("Active")) return "from-[#4951EC] to-[#3640C4]";
    if (title?.includes("Booking")) return "from-blue-400 to-blue-600";
    if (title?.includes("Registration")) return "from-purple-400 to-purple-600";
    if (title?.includes("Revenue")) return "from-green-400 to-green-600";
    return "from-gray-400 to-gray-600";
  };

  return (
    <div
      className={`bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-200 hover:scale-[1.02] m-1.5 p-5 ${
        size === "revenue" ? "w-[33%]" : "flex-[0.95]"
      }`}
      onClick={onClick}
    >
      {/* Header with Icon and Title */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`${getIconBgColor()}  rounded-lg`}>
            <img
              src={image}
              className={`${
                card === "booking2"
                  ? "h-5 w-5"
                  : card === "booking1"
                  ? "h-6 w-6"
                  : "h-6 w-6"
              }`}
              alt={title}
            />
          </div>
          <p
            className={`text-sm font-semibold ${
              size === "revenue" || user === "dash" || user === "dash1"
                ? "text-gray-700"
                : isActive
                ? "text-blue-500"
                : "text-gray-400"
            }`}
          >
            {title}
          </p>
          {onInfoClick && (
            <button 
              onClick={(e) => { e.stopPropagation(); onInfoClick(); }} 
              className="text-blue-600 hover:text-blue-700 transition-colors p-1"
              title="View details"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
            </button>
          )}
        </div>
        {trend !== undefined && trend !== null && (
          <div className="flex items-center gap-1">
            {trend > 0 ? (
              <>
                <svg
                  className="w-4 h-4 text-green-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 10l7-7m0 0l7 7m-7-7v18"
                  />
                </svg>
                <span className="text-sm font-semibold text-green-600">
                  {trend}%
                </span>
              </>
            ) : trend < 0 ? (
              <>
                <svg
                  className="w-4 h-4 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 14l-7 7m0 0l-7-7m7 7V3"
                  />
                </svg>
                <span className="text-sm font-semibold text-red-600">
                  {trend}%
                </span>
              </>
            ) : (
              <span className="text-sm font-semibold text-gray-500">0%</span>
            )}
          </div>
        )}
      </div>

      {/* Active Users Card with Linear Progress */}
      {user === "dash1" && (
        <div className="mt-2 flex flex-col items-center">
          <div className="flex items-center justify-center mb-2 w-full">
            <span className="text-4xl font-bold text-gray-800">
              {count === "Loading..." ? (
                <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-8 w-8 text-[#4951EC]"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                </div>
              ) : (
                count
              )}
            </span>
            <span className="text-2xl font-bold text-gray-400">
              {progress}%
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2">
            <div
              className={`bg-gradient-to-r ${getProgressColor()} h-2.5 rounded-full transition-all duration-500`}
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-xs text-gray-500 text-center">{text}</p>
        </div>
      )}

      {/* Regular Metric Cards (Bookings, Registrations, Revenue) */}
      {(user === "dash" || user === "userAqu") && (
        <div className="mt-2 flex flex-col items-center">
          <div className="flex items-baseline gap-2 justify-center">
            <span className="text-4xl font-bold text-gray-800">
              {count === "Loading..." ? (
                <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-8 w-8 text-[#4951EC]"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  <span className="text-sm text-gray-500">Loading...</span>
                </div>
              ) : (
                count
              )}
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-2 text-center">{text}</p>
        </div>
      )}

      {/* Engagement cards with simplified layout */}
      {(user === "engagement" || user === "engagement1") && (
        <div className="mt-2 flex flex-col items-center">
          <div className="flex items-baseline gap-2 justify-center">
            <span className="text-4xl font-bold text-gray-800">
              {count === "Loading..." ? (
                <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-8 w-8 text-[#4951EC]"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="2"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  <span className="text-sm text-gray-500">Loading...</span>
                </div>
              ) : (
                count
              )}
            </span>
          </div>
          <p className="text-sm text-gray-500 mt-2 text-center">{text}</p>

          {/* Active indicator for selected engagement card */}
          {isActive && (
            <div className="mt-3 flex justify-center">
              <div className="h-1.5 w-1/2 bg-[#4951EC] rounded-xl"></div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CommonCard;
